<template>
  <header class="h-[60px] tablet:h-[90px] relative z-40 avenir-cond">
    <div
      class="fixed top-0 left-0 right-0 z-40 bg-white h-[60px] tablet:h-[90px] w-full max-w-full min-w-0 overflow-visible flex items-center justify-start text-[15px] xl:text-lg"
    >
      <div class="max relative min-w-0">
        <img
          fetchpriority="high"
          src="@/assets/images/burger.png"
          @click="toggle"
          class="tablet:hidden fa-bars absolute text-4xl z-50 left-5 top-[48px] mini:top-[55px]"
        />

        <div class="flex tablet:hidden items-center justify-center relative">
          <router-link to="/"
            ><img
              fetchpriority="high"
              src="@/assets/images/logo.svg"
              class="w-[85px] mini:w-[100px] mx-auto mt-10"
              alt="Petit Navire"
          /></router-link>
          <a
            href="https://tracabilite.petitnavire.fr"
            target="_blank"
            class="absolute right-0 top-[38px] mini:top-[42px]"
          >
            <img
              src="@/assets/images/Encart.svg"
              alt="D'où vient votre poisson ?"
              class="w-[110px] mini:w-[130px] h-auto"
            />
          </a>
        </div>

        <div class="hidden tablet:flex items-center justify-between relative">
          <router-link to="/"
            ><img
              fetchpriority="high"
              src="@/assets/images/logo.svg"
              class="absolute w-28 -top-6 lg:-top-2 left-0"
              alt="Petit Navire"
          /></router-link>
          <div class="relative w-28"></div>
          <div>
            <ul
              class="flex items-center justify-center gap-4 xl:gap-6 font-bold text-[#0F3564]"
            >
              <li>
                <a href="https://petitnavire.fr/fr/la-marque" target="_blank"
                  >La marque</a
                >
              </li>
              <li>
                <a href="https://petitnavire.fr/fr/engagements" target="_blank"
                  >Nos engagements</a
                >
              </li>
              <li>
                <a href="https://petitnavire.fr/fr/nos-produits" target="_blank"
                  >Nos produits</a
                >
              </li>
              <li>
                <a href="https://petitnavire.fr/fr/nos-recettes" target="_blank"
                  >Nos recettes</a
                >
              </li>
              <li>|</li>
              <li>
                <a
                  href="https://tracabilite.petitnavire.fr"
                  class="bg-[#0F3564] flex items-center justify-center text-[15px] rounded-[50px] border border-[#0F3564] text-white cursor-pointer hover:bg-white hover:text-[#0F3564] transition-all duration-300"
                  style="width: 220px; height: 58px;"
                  target="_blank"
                  >D'où vient votre poisson ?</a
                >
              </li>
              <li>
                <router-link to="/contact" class="font-normal"
                  >Nous contacter</router-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="relative">
          <Teleport to="body">
            <Drawer @close="toggle" align="left" :closeable="true">
              <div v-if="open">
  
                <img
                  src="@/assets/images/logo.svg"
                  class="w-[120px] mx-auto mt-6"
                  alt="logo"
                />
                <div
                  class="text-white text-sm uppercase font-bold w-full text-center"
                >
                  <ul class="mt-8">
                    <li @click="toggle" class="py-3">
                      <a
                        href="https://petitnavire.fr/fr/la-marque"
                        target="_blank"
                        >La marque</a
                      >
                    </li>
                    <li @click="toggle" class="py-3">
                      <a
                        href="https://petitnavire.fr/fr/engagements"
                        target="_blank"
                        >Nos engagements</a
                      >
                    </li>
                    <li @click="toggle" class="py-3">
                      <a
                        href="https://petitnavire.fr/fr/nos-produits"
                        target="_blank"
                        >Nos produits</a
                      >
                    </li>
                    <li @click="toggle" class="py-3">
                      <a
                        href="https://petitnavire.fr/fr/nos-recettes"
                        target="_blank"
                        >Nos recettes</a
                      >
                    </li>
                    <!--<li @close="toggle" class="py-2">
                      <a
                        class="bg-white block py-1 px-2 w-fit mx-auto rounded-full text-[#0F3564]"
                        >D'où vient votre poisson ?</a
                      >
                    </li> -->
                    <li @click="toggle" class="py-2"><router-link to="/contact"
             
             >Nous contacter</router-link></li>
                  </ul>
                </div>
              </div>
            </Drawer>
          </Teleport>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import Drawer from "vue-simple-drawer";
import Teleport from "vue2-teleport";

export default {
  name: "header-view",
  components: {
    Drawer,
    Teleport,
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggle() {
      console.log("toggle");
      this.open = !this.open;
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>
<style scoped>
.card {
  box-shadow: 0 1px 13px 5px rgba(0, 26, 72, 0.15);
}
</style>
